module.exports = __webpack_public_path__ + "img/profile.b224ab78.png";